// extracted by extract-css-chunks-webpack-plugin
module.exports = {"story__cont":"_2fFbi","story-image__cont":"t6Z_2","story-image__overlay":"_3iXyi","story-body__cont":"_3_EVz","story-title":"IGgga"};